import { React, useState, useRef } from "react";
import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  increment,
  arrayUnion,
} from "firebase/firestore";
import { authService } from "fbase";
import { ReactSketchCanvas } from "react-sketch-canvas";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";

const styles = {
  border: "0.0625rem solid #9c9c9c",
  borderRadius: "0.25rem",
};

const Solve = (props) => {
  const [imgLink, setImageLink] = useState();
  const [answer, setAnswer] = useState();
  const [qAnswer, setQAnswer] = useState();
  const [qNum, setQNum] = useState();
  const [startTime, setStartTime] = useState();
  const [avgTime, setAvgTime] = useState(0);
  const [startNum, setStartNum] = useState(props.qNumRange[0]);
  const [endNum, setEndNum] = useState(props.qNumRange[1]);
  const [pointer, setPointer] = useState("all");
  const [isFirst, setIsFirst] = useState(true);
  const [correctRate, setCorrectRate] = useState({});

  const db = getFirestore();
  const userUID = authService.currentUser.uid;
  const canvasRef = useRef(null);

  const newQuestion = async () => {
    canvasRef.current.clearCanvas();
    setAvgTime(0);
    if (endNum < startNum) {
      window.alert("문제 범위 오류");
      return 0;
    }
    const testList = props.testList;
    const test = testList[Math.floor(Math.random() * testList.length)];
    const month = test.slice(-2);
    let year = test.slice(0, 2);
    if (month === "06" || month === "09" || month === "11") {
      year = String(parseInt(test.slice(0, 2)) - 1);
    }
    let randNum =
      Math.floor(Math.random() * (endNum - startNum + 1)) + startNum;
    if (randNum < 10) randNum = "0" + randNum;
    const randQNum = test + randNum;
    const docRef = doc(db, props.subject, randQNum);
    const docSnap = await getDoc(docRef);
    if (docSnap) {
      setQNum(randQNum);
      setImageLink(
        "https://storage.googleapis.com/pacemaker_storage/%E1%84%80%E1%85%AA%E1%84%90%E1%85%A1%E1%86%B7%E1%84%80%E1%85%B5%E1%84%8E%E1%85%AE%E1%86%AF/" +
          props.subject +
          "/img/" +
          year +
          "/" +
          month +
          "/" +
          randQNum +
          ".jpg"
      );
      setQAnswer(docSnap.data().answer);
      let data = docSnap.data();
      const correctRateObj = {};
      data.correctCount && (correctRateObj.correctCount = data.correctCount);
      data.wrongCount && (correctRateObj.wrongCount = data.wrongCount);
      data.firstCorrectCount &&
        (correctRateObj.firstCorrectCount = data.firstCorrectCount);
      data.firstWrongCount &&
        (correctRateObj.firstWrongCount = data.firstWrongCount);
      setCorrectRate(correctRateObj);
      delete data.answer;
      if (data[userUID]) setIsFirst(false);
      let dataArr = Object.values(data);
      if (randNum < 6) {
        for (let i = 0; i < dataArr.length; i++) {
          if (dataArr[i] > 300000) {
            dataArr.splice(i, 1);
            i--;
          }
        }
      } else if (randNum < 11) {
        for (let i = 0; i < dataArr.length; i++) {
          if (dataArr[i] > 600000 || dataArr[i] < 5000) {
            dataArr.splice(i, 1);
            i--;
          }
        }
      } else if (randNum < 16) {
        for (let i = 0; i < dataArr.length; i++) {
          if (dataArr[i] > 600000 || dataArr[i] < 10000) {
            dataArr.splice(i, 1);
            i--;
          }
        }
      } else if (randNum < 21) {
        for (let i = 0; i < dataArr.length; i++) {
          if (dataArr[i] > 600000 || dataArr[i] < 15000) {
            dataArr.splice(i, 1);
            i--;
          }
        }
      }
      if (dataArr.length > 0)
        setAvgTime(dataArr.reduce((a, b) => a + b, 0) / dataArr.length);
    } else {
      console.log("no db");
    }
    const currentTime = Date.now();
    setStartTime(currentTime);
    setAnswer();
  };
  const nextQuestion = async () => {
    canvasRef.current.clearCanvas();
    const currentTime = Date.now();
    const correct = answer === qAnswer;
    window.alert(
      `정답 : ${
        answer === qAnswer ? correct : "false, " + qAnswer
      } \n소요 시간 : ${
        (currentTime - startTime) / 1000
      }s\n정답자 평균 소요 시간 : ${avgTime / 1000}s `
    );
    let solveInfoObj = {};
    solveInfoObj[qNum] = arrayUnion({
      correct: correct,
      time: currentTime - startTime,
      type: null,
      date: currentTime,
    });
    await setDoc(doc(db, userUID, props.subject), solveInfoObj, {
      merge: true,
    });
    if (correct) {
      let obj = {};
      if (isFirst) obj.firstCorrectCount = increment(1);
      obj[userUID] = currentTime - startTime;
      await updateDoc(doc(db, props.subject, qNum), {
        ...obj,
        correctCount: increment(1),
      });
    } else {
      let obj = {};
      if (isFirst) obj.firstWrongCount = increment(1);
      await updateDoc(doc(db, props.subject, qNum), {
        ...obj,
        wrongCount: increment(1),
      });
    }
    newQuestion();
  };

  // const addQ = async () => {
  //   for (let i = 0; i < qArr.length; i++) {
  //     let obj = {};
  //     obj["answer"] = qArr[i][1];
  //     obj["imgLink"] = qArr[i][2];
  //     await setDoc(doc(db, "Social", `${qArr[i][0]}`), obj, { merge: true });
  //   }
  // };
  // addQ();
  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;
  return (
    <div
      style={{
        height: `${windowHeight * 0.89}px`,
        width: `${windowWidth * 0.95}px`,
        backgroundColor: "#FCF6F5",
        overflow: "scroll",
      }}
    >
      <div>
        {qNum} 실시간 정답률 - 최초 풀이 :{" "}
        {Number.parseFloat(
          (correctRate.firstCorrectCount /
            (correctRate.firstCorrectCount + correctRate.firstWrongCount)) *
            100
        ).toFixed(1)}
        % 누적 :{" "}
        {Number.parseFloat(
          (correctRate.correctCount /
            (correctRate.correctCount + correctRate.wrongCount)) *
            100
        ).toFixed(1)}
        %
      </div>
      <div style={{ backgroundColor: "white" }}>
        <ReactSketchCanvas
          style={styles}
          ref={canvasRef}
          width={windowWidth * 0.95}
          height={windowHeight * 0.7}
          strokeWidth={0.5}
          strokeColor="black"
          backgroundImage={imgLink}
          preserveBackgroundImageAspectRatio="xMinYMin"
          exportWithBackgroundImage={true}
          allowOnlyPointerType={pointer}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "5px",
        }}
      >
        <Button
          size="small"
          variant="contained"
          style={{ marginLeft: "5px", fontSize: "0.5rem" }}
          onClick={newQuestion}
        >
          {!qNum ? "시작" : "새문항"}
        </Button>
        <Button
          size="small"
          variant="contained"
          style={{ marginLeft: "5px", fontSize: "0.5rem" }}
          onClick={() => {
            canvasRef.current.clearCanvas();
          }}
        >
          전체 지우기
        </Button>
        <Button
          size="small"
          variant="contained"
          style={{ marginLeft: "5px", fontSize: "0.5rem" }}
          onClick={() => {
            canvasRef.current.undo();
          }}
        >
          한 획 지우기
        </Button>
        <Switch
          checked={pointer === "all"}
          onChange={() => {
            pointer === "all" ? setPointer("pen") : setPointer("all");
          }}
          inputProps={{ "aria-label": "controlled" }}
        />
        <div
          style={{ display: "flex", alignItems: "center", fontSize: "0.5rem" }}
        >
          손가락 터치
        </div>
      </div>
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "5px" }}
      >
        <FormControl>
          <RadioGroup
            row
            size="small"
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            onChange={(event) => {
              setAnswer(Number(event.target.value));
            }}
            value={answer ? answer : 0}
          >
            <FormControlLabel
              value={1}
              control={<Radio size="small" />}
              label="1"
            />
            <FormControlLabel
              value={2}
              control={<Radio size="small" />}
              label="2"
            />
            <FormControlLabel
              value={3}
              control={<Radio size="small" />}
              label="3"
            />
            <FormControlLabel
              value={4}
              control={<Radio size="small" />}
              label="4"
            />
            <FormControlLabel
              value={5}
              control={<Radio size="small" />}
              label="5"
            />
          </RadioGroup>
        </FormControl>
        <Button
          size="small"
          variant="contained"
          style={{ marginLeft: "5px", fontSize: "0.5rem" }}
          onClick={nextQuestion}
        >
          제출
        </Button>
      </div>
    </div>
  );
};
export default Solve;
